import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave, faSearch, faArrowLeft, faArrowRight, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './APRetention.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import GoCast from '../../Images/GoCast.png'

function ApRetention_Dashboard() {
    const [isLoading, setIsLoading] = useState(false); // Loading GIF

    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);
    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_PurChargeData_v1(PRECAST)/api/v1/BaqSvc/IIT_P_ElementForUnHold_KV3(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                console.log('API Data:', data.value);
                setApiData(data.value);
                setIsLoading(false); // Load GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
            setIsLoading(false); // Load GIF
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.PurMisc_MiscCode}</td>
                <td>{item.APInvMsc_InvoiceNum}</td>
                <td>{item.APInvMsc_InvoiceLine}</td>
                <td>{item.APInvHed_REFPONum}</td>
                <td>{item.APInvHed_InvoiceDate}</td>
                <td>{item.APInvHed_ApplyDate}</td>
                <td>{item.Vendor_VendorID}</td>
                <td>{item.Vendor_Name}</td>
                <td>{item.APInvMsc_DocMiscAmt}</td>
                <td>{item.PurMisc_Retention_c}</td>
                <td>{item.APInvHed_Posted}</td>
                <td>{item.Calculated_InvoiceDateTo}</td>
                <td>{item.Calculated_ApplyDateTo}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    return (
        <div className='APretention'>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='card rebartable'>
                <div className="card-header-apretention">
                    {/* <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                        <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                    </button> */}
                    {/* <h2 className='panel-title'>AP Retention Details</h2> */}
                    <div className='Element-id-container'>
                        <input type='text' placeholder='Charge ID' className='Elementidinput' />
                    </div>

                    <div className='ctrl-btns-trans-apretention'>
                        {/* Existing buttons */}
                        <button className="btn" id='add'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='save'>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#save"
                            content="Save"
                            place='bottom'
                        />
                        {/* <button type="button" className="search-icon" onClick={toggleSearch}>
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                        <Tooltip
                            anchorSelect=".search-icon"
                            content="Advanced Search"
                            place='bottom'
                        /> */}
                        {/* New button to toggle table visibility */}

                        {/* Existing search div */}
                        <div className={`main-search-bar ${searchOpen ? 'open' : ''}`} id="searchBar" style={{ height: '650px', overflowY: 'scroll' }}>
                            {/* Search form */}
                            {/* <form className="search-filter">
                                <h3 className="search-title">Search Filter <FontAwesomeIcon icon={faSearch} /></h3>
                                <input type="text" placeholder="Charge ID" name="filter1" />
                                <input type="text" placeholder="Invoice=" name="filter2" />
                                <input type="text" placeholder="PO" name="filter3" />
                                <input type="date" placeholder="Invoice Date" name="filter3" />
                                <input type="date" placeholder="To" name="filter3" />
                                <input type="date" placeholder="Apply Date" name="filter3" />
                                <input type="date" placeholder="To" name="filter3" />
                                <input type="text" placeholder="Supp ID= " name="filter3" />
                                <input type="text" placeholder="Supp Name >= " name="filter3" />
                                <button type="submit">Search</button>
                                <button type="reset" onClick={toggleSearch}>Cancel</button>
                            </form> */}
                        </div>
                    </div>
                </div>
                {/* Conditionally render the table */}
                {tableVisible && (
                    <div className="card-body" style={{ overflowY: 'scroll' }}>
                        <div class="table-responsive-sm">
                            <table className="table table-bordered">
                                {/* Table content */}
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white text-nowrap'>
                                        <th>Charge ID</th>
                                        <th>Invoice</th>
                                        <th>PO</th>
                                        <th>Invoice Date</th>
                                        <th>Apply Date</th>
                                        <th>Supplier</th>
                                        <th>Name</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderTableRows()}
                                </tbody>
                            </table>
                            <div className="pagination">
                                <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </button>
                            </div>
                        </div>

                    </div>

                )}
            </div>
        </div>
    );
}

export default ApRetention_Dashboard;
